import { render, staticRenderFns } from "./orderProductionTransferPopover.vue?vue&type=template&id=aaef70de&scoped=true&"
import script from "./orderProductionTransferPopover.vue?vue&type=script&lang=js&"
export * from "./orderProductionTransferPopover.vue?vue&type=script&lang=js&"
import style0 from "./orderProductionTransferPopover.vue?vue&type=style&index=0&id=aaef70de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaef70de",
  null
  
)

export default component.exports